import Booking, { getBookingName } from "../../../../shared/functions/booking";
import Store from "../../../../shared/functions/store";
import Config from "../../../../config";
import User from "@phoenixreisen/user";
import Draggable from "draggable";
import m from "mithril";
const Link = m.route.Link;
export default class {
    open = false;
    oncreate() {
        new Draggable(document.querySelector("#admin-nav"), {
            handle: document.querySelector("#dragger"),
            setPosition: false,
            onDragStart: (el) => {
                el.style.bottom = "auto";
            },
        });
    }
    toggle(status) {
        this.open = !status;
    }
    reload() {
        Store.remove(Config.storageKeyBooking);
        location.reload();
    }
    view() {
        const { urls } = Config;
        const { data } = Booking;
        const { pathname } = location;
        const name = getBookingName(data) || "";
        const email = (data && data["buchung/email"]) || null;
        const routes = (data && data["buchung/routen"]) || [];
        const bookingnr = (data && data["buchung/rech-nr"]) || null;
        const additionals = (data && data["buchung/zubuchungen"]) || [];
        const isInApp = urls.MNGMNT.includes(pathname.slice(0, -1));
        return (m("article", { id: "admin-nav" },
            m("div", { class: `admin-nav ${this.open ? "admin-nav--open" : ""}` },
                m("div", { id: "dragger", class: "admin-nav__dragger" },
                    m("i", { class: "fas fa-bars" })),
                m("div", { class: "admin-nav__bookingdata" },
                    m("table", null,
                        bookingnr ? (m("tr", null,
                            m("td", null, "Buchung:"),
                            m("td", null, bookingnr))) : (""),
                        additionals.length ? (m("tr", null,
                            m("td", null, "Zubuchung:"),
                            m("td", null, additionals.join(", ")))) : (""),
                        name ? (m("tr", null,
                            m("td", null, "Name:"),
                            m("td", null, name))) : (""),
                        email ? (m("tr", null,
                            m("td", null, "Email:"),
                            m("td", null, email))) : (""),
                        routes.length ? (m("tr", null,
                            m("td", null, "Route:"),
                            m("td", null, routes.map((route, index) => {
                                return (m("a", { key: index, href: route["route/link"], title: "Reiseroute aufrufen", rel: "noopener noreferrer", target: "_blank", class: "mr1" },
                                    route["route/schiff"],
                                    route["route/route"]));
                            })))) : (""))),
                m("div", { class: "admin-nav__links" },
                    isInApp ? (m(Link, { href: "/stellvertretung-uebernehmen", title: "Stellvertretung" },
                        m("i", { class: " fas fa-user mr2" }),
                        "Stellvertretung")) : (m("a", { href: `${urls.MNGMNT}/#!/stellvertretung-uebernehmen`, title: "Stellvertretung" },
                        m("i", { class: " fas fa-user mr2" }),
                        "Stellvertretung")),
                    m("span", { class: "mh2" }, "|"),
                    m("a", { href: "javascript:void(0)", title: "Buchung frisch ziehen", onclick: () => this.reload() },
                        m("i", { class: "fas fa-sync mr2" }),
                        "Buchung")),
                m("a", { href: "javascript:void(0)", class: "admin-nav__toggler", title: "Navigation ein- und ausfahren", onclick: () => this.toggle(this.open) },
                    "Mitarbeiter",
                    this.open ? (m("i", { class: "fas fa-chevron-down ml2" })) : (m("i", { class: "fas fa-chevron-up ml2" }))),
                m("ul", null,
                    isInApp
                        ? [
                            Booking.data && (m("li", null,
                                m(Link, { href: "/kundenverwaltung", title: "Kundenverwaltung" }, "Kundenverwaltung"))),
                            Booking.data && (m("li", null,
                                m(Link, { href: "/ueberland-zuteilung", title: "Zuteilung \u00DCberland" }, "\u00DCberland-Zuteilung"))),
                        ]
                        : [
                            Booking.data && (m("li", null,
                                m("a", { href: `${urls.MNGMNT}/#!/kundenverwaltung`, title: "Kundenverwaltung" }, "Kundenverwaltung"))),
                            Booking.data && (m("li", null,
                                m("a", { href: `${urls.MNGMNT}/#!/ueberland-zuteilung`, title: "Zuteilung \u00DCberland" }, "\u00DCberland-Zuteilung"))),
                        ],
                    m("li", null,
                        m("a", { href: urls.PASSWORD_CHANGE_PHX, title: "Dein Passwort \u00E4ndern" }, "Dein Passwort \u00E4ndern")),
                    User.isAdmin() && (m("li", null,
                        m("a", { href: urls.WEBTEXT, title: "Webtexte \u00E4ndern" }, "Webtexte anpassen")))))));
    }
}
